module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, _vm._l((this.apiData), function(item) {
    return _c('BudgetDetail', {
      key: item.id,
      staticClass: "col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4",
      attrs: {
        "id": item.id,
        "type": item.type,
        "amount": item.amount,
        "actions": item.actions,
        "active": item.active,
        "linked": item.linked,
        "selectedColor": item.selectedColor
      },
      on: {
        "checkbox-change": _vm.handleCheckboxChange
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30a75285"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BodyBudget.vue
// module id = 93
// module chunks = 1